<template>
    <div>
        <div class="d-flex mb-2">
            <div style="width: 30%" class="mr-2">
                <v-select
                    class="booking-select"
                    :options="conditionFields"
                    v-model="condition.field"
                    @input="onFieldChange"
                ></v-select>
            </div>
            <div style="width: 30%" class="mr-2">
                <v-select
                    :options="options"
                    v-model="condition.value"
                    label="label"
                    multiple="multiple"
                    @input="onValueChange"
                ></v-select>
            </div>
            <div style="width: 20%" class="mr-2">
                <strong>{{ condition.operator }}</strong>
            </div>
            <div style="width: 10%">
                <span class="material-icons-outlined cursor-pointer mr-1 text-primary"
                      @click="removeCondition"
                      title="Remove condition"
                >delete</span>
            </div>
        </div>

    </div>

</template>

<script>


export default {
    name: "ConditionSingle",
    props: {
        blockId: {type: String, required: false},
        conditionId: {type: String, required: false},
        conditionProp: {type: Object, required: true},
    },
    data() {
        return {
            condition: this.conditionProp,
            conditionFields: this.$parent.$parent.conditionFields,
            conditionTypes: this.$parent.$parent.conditionTypes,
            options: []
        }
    },
    mounted() {
        this.onFieldChange();
    },
    methods: {
        onFieldChange() {
            this.options = this.conditionTypes[this.condition.field];
            this.$parent.$parent.setCondition(this.blockId, this.conditionId, this.condition);
        },
        onValueChange() {
            this.$parent.$parent.setCondition(this.blockId, this.conditionId, this.condition);
        },
        removeCondition() {
            this.$parent.$parent.removeCondition(this.blockId, this.conditionId);
        },
    }


}
</script>

<style scoped>

</style>
